
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"304","height":"304","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M301.492 118.507L152 268 1.918 117.918C34.92 70.805 89.612 40 151.5 40c62.145 0 117.036 31.062 149.992 78.507z","fill":"#fff","fill-opacity":".05"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M248.874 171.126L152 268l-96.874-96.874C79.918 146.334 114.168 131 152 131c37.831 0 72.082 15.334 96.874 40.126z","fill":"#fff","fill-opacity":".05"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M177.456 242.544L152 268l-25.456-25.456C133.059 236.029 142.059 232 152 232c9.941 0 18.941 4.029 25.456 10.544z","fill":"#fff","fill-opacity":".05"}}),_c('circle',{attrs:{"cx":"252","cy":"52","r":"36","fill":"#787878"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M254 32h-4v24h4V32zm-2 40a4 4 0 100-8 4 4 0 000 8z","fill":"#232323"}})])
          )
        }
      }
    